import React from "react"
import styled from "styled-components"
import theme from "@src/styles/theme"
import Image from "../core-image"
import { useMediaPartners } from "@src/hooks/useMediaPartners"

const MediaWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 56px;

  @media (max-width: 600px) {
    padding-bottom: 32px;
  }
`

const MediaTrack = styled.div`
  background: ${theme.blackShade};
  width: 100%;
  height: 95px;
  display: flex;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 1440px) {
    max-width: 1440px;
  }

  @media (max-width: 1024px) {
    padding: 0 16px;
    justify-content: flex-start;
  }
`

const LogoHolders = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 67px;
  width: 100%;
  max-width: 1280px;

  & .lazyload-wrapper {
    & > img {
      filter: brightness(0) invert(1);
    }
    &:last-child {
      & > img {
        filter: invert(1);
      }
    }
  }
  @media (max-width: 1440px) {
    max-width: 1140px;
  }

  @media (max-width: 1260px) {
    max-width: 960px;
  }

  @media (max-width: 1024px) {
    justify-content: flex-start;
  }

  @media (max-width: 600px) {
    justify-content: flex-start;
    gap: 32px;
  }

  @media only screen and (${props => props.theme.screen.mobile.max}) {
    & .lazyload-wrapper:nth-last-child(-n + 2) {
      display: none;
    }
  }
`

const TitleDesktop = styled.div`
  color: ${theme.whiteShade};
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 0.5px;
  text-wrap: nowrap;
  @media only screen and (${props => props.theme.screen.small.max}) {
    display: none;
  }
`

const TitleMobile = styled.div`
  display: none;
  color: ${theme.blackShade};
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.5px;

  @media only screen and (${props => props.theme.screen.small.max}) {
    display: block;
    margin-bottom: 20px;
  }
`

function Media() {
  const tourMedia = useMediaPartners(true)
  return (
    <MediaWrapper>
      <TitleMobile>As seen in</TitleMobile>
      <MediaTrack>
        <LogoHolders>
          <TitleDesktop>As seen in</TitleDesktop>
          {tourMedia.map(media => (
            <Image key={media.title} {...media.logoTile} />
          ))}
        </LogoHolders>
      </MediaTrack>
    </MediaWrapper>
  )
}

export default Media
